// extracted by mini-css-extract-plugin
export default {"container":"kiosk-relations-table_container__2du6U","delete":"kiosk-relations-table_delete__NbX38","table":"kiosk-relations-table_table__Lv7dq"};